import { useRef, Fragment, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field } from 'formik';
import styled, { withTheme } from 'styled-components';
import { useCookies } from 'react-cookie';
import * as yup from 'yup';

import {
    FovInput,
    FovFieldError,
    Tags,
    VerticalSpacer,
    FovButton,
    H5,
} from 'components';

import { updateTeamIdAdmin } from 'store/actions/admin';

import { TitleContainer } from './styles';

const ButtonContainer = styled('div')`
    display: inline-flex;
    width: 100%;
    max-width: 25rem;
`;

const InputContainer = styled('div')`
    max-width: 25rem;
`;

export const Settings = withTheme(() => {

    const dispatch = useDispatch();
    const formikRef = useRef();
    const adminDataStore = useSelector(state => state.adminData);

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;

    const selectedTeamData = useMemo(() => adminDataStore.selectedTeamData, [ adminDataStore.selectedTeamData ]);
    const domains = selectedTeamData?.allowed_domains?.join(',') || '';
    const displayName = selectedTeamData.display_name;

    const setRef = form => {
        if (!formikRef.current) {
            formikRef.current = form;
        }
    };

    const handleSubmit = useCallback(args => {
        const { values, setSubmitting } = args;
        const { displayName, domains } = values;
        const domainArr = domains.split(',');

        dispatch(updateTeamIdAdmin(token, selectedTeamData.team_id, { displayName, domains: domainArr }))
            .finally(setSubmitting(false));
    }, [ selectedTeamData ]);

    const defaults = {
        displayName: displayName || '',
        domains: domains || '',
    };

    const schema = yup.object().shape({
        displayName: yup.string().required('A display name is required.'),
        domains: yup.string().required('At least one domain is required.')
            .test(
                'is-valid',
                'All domains must start with @',
                value => value?.split?.(',').every(domain => domain.startsWith('@')),
            ),
    });


    return (
        <Fragment>
            <TitleContainer>
                <H5>Settings</H5>
            </TitleContainer>
            <VerticalSpacer size={7} />
            <Formik
                initialValues={defaults}
                validationSchema={schema}
                onSubmit={(values, handlers) => {
                    const { setSubmitting } = handlers;
                    handleSubmit({ values, setSubmitting });
                }}
                validateOnChange={true}
            >
            {form => (
                <Fragment>
                {setRef(form)}
                Display Name
                <Field type='text' name='displayName'>
                {data => (
                    <InputContainer>
                        <FovInput
                            value={data.field.value}
                            placeholder={displayName}
                            {...data.field}
                            onChange={e => {
                                const newVal = e.target.value;
                                form.setFieldValue(data.field.name, newVal);
                            }}
                        />
                    </InputContainer>
                )}
                </Field>
                <FovFieldError name='displayName' />

                Domains
                <VerticalSpacer size={10} />

                <Field type='input' name='domains'>
                {data => (
                    <Tags
                        values={data.field.value ? data.field.value : []}
                        newTagText='Add domain'
                        onChange={(e, domains) => {
                            form.setFieldValue(data.field.name, domains);
                        }}
                    />
                )}
                </Field>
                <FovFieldError name='domains' />
                <ButtonContainer>
                    <FovButton
                        type='submit'
                        disabled={form.isSubmitting}
                        onClick={form.handleSubmit}
                    >
                    Save Settings
                    </FovButton>
                </ButtonContainer>


                </Fragment>
            )}
            </Formik>
        </Fragment>
    );
});
